import { render, staticRenderFns } from "./CandidatePortal.vue?vue&type=template&id=79fcbee4&scoped=true&"
import script from "./CandidatePortal.vue?vue&type=script&lang=js&"
export * from "./CandidatePortal.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePortal.vue?vue&type=style&index=0&id=79fcbee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fcbee4",
  null
  
)

export default component.exports